import { sessionService as ss } from 'redux-react-session';
import _includes from 'lodash/includes';
import { errorActions } from 'features/error';
import { errorTypes, errorMessages } from 'helpers/constants';
import { clearStore } from 'features/store';

const { ACCESS_TOKEN_INVALID, NOT_AUTHENTICATED, RECORD_NOT_FOUND } = errorTypes;
const { ACCESS_TOKEN_EMPTY } = errorMessages;

const deleteActiveSession = async () => {
  await ss.loadSession().catch(e => console.error(e));
  await ss.deleteSession().catch(e => console.error(e));
};

const errorMiddleware = store => next => action => {
  if (action.type && action.type.endsWith('/rejected')) {
    const error = action.payload;
    const type = error.type ?? null;
    const message = error.message ?? null;

    if  ((type === ACCESS_TOKEN_INVALID || (type === NOT_AUTHENTICATED && store.getState().session.authenticated) || message === ACCESS_TOKEN_EMPTY)) {
      deleteActiveSession()
      .then(() => {
        store.dispatch(clearStore());
        store.dispatch(errorActions.setError(error));
      });
    } else {
      if (!(_includes(action.type, 'Flow') && type === RECORD_NOT_FOUND)) {
        store.dispatch(errorActions.setError(error));
      }
    }
  } 
  return next(action);
};

export default errorMiddleware;